var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"spinner-wrapper"}},[_c('div',{staticClass:"profile-main-spinner"},[_c('div',{staticClass:"spinner-loader"},[_c('svg',{staticClass:"circular-loader",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"spinner-path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke":"#fff","stroke-width":"4"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }